<p-card class="product-card">
  <ng-template pTemplate="header">
    <div>
      <div class="image">
        <img
          [alt]="getTextLabel(productDetail?.productType)"
          [src]="getImageLabel(productDetail?.productType)"
        />
        <label class="image-label">{{
          getTextLabel(productDetail?.productType)
        }}</label>
      </div>
      <img
        class="product-image"
        alt="Card"
        [src]="getProductImage(productDetail?.productType)"
      />
    </div>
  </ng-template>
  <ng-container *transloco="let t">
    <div class="content">
      <div class="title">
        <span *ngIf="productDetail.productType === PAYDAY">{{
          t('loanProductShelf.productDetail.paydayTitle')
        }}</span>
        <span *ngIf="productDetail.productType === THUNGNGERN">{{
          t('loanProductShelf.productDetail.100kTitle')
        }}</span>
        <span *ngIf="productDetail.productType === SMART_MONEY">{{
          t('loanProductShelf.productDetail.smTitle')
        }}</span>
      </div>
      <div class="description p-d-flex p-jc-between">
        <div class="title">
          {{ t('loanProductShelf.productDetail.maximumLimit') }}
        </div>
        <div class="value">
          <div class="bold">
            {{ productDetail?.maxCreditLimit | currency: ' ':'symbol':'1.0-0' }}
          </div>
          <!-- {{ t('loanProductShelf.productDetail.baht') }} -->
        </div>
      </div>
      <div class="description p-d-flex p-jc-between">
        <div class="title">
          {{ t('loanProductShelf.productDetail.interestRate') }}
        </div>
        <div class="value">
          <div class="bold">{{ productDetail?.maxInterestRate }}%</div>
        </div>
      </div>
      <!-- <div class="description p-d-flex p-jc-between">
        <ng-container *ngIf="productDetail.productType !== SMART_MONEY">
          <div class="title">
            {{ t('loanProductShelf.productDetail.periodTime') }}
          </div>
          <div
            *ngIf="productDetail?.customerDetail?.selectablePaymentTerms"
            class="value"
          >
            {{
              productDetail?.customerDetail?.selectablePaymentTerms
                ?.slice(-1)
                ?.pop()
                ? productDetail?.customerDetail?.selectablePaymentTerms
                    ?.slice(-1)
                    ?.pop()
                : '-'
            }}
            {{
              productDetail?.customerDetail?.selectablePaymentTerms
                ?.slice(-1)
                ?.pop() && t('loanProductShelf.productDetail.month')
            }}
          </div>
          <div *ngIf="!productDetail?.customerDetail?.selectablePaymentTerms">
            -
          </div>
        </ng-container>
        <ng-container *ngIf="productDetail.productType === SMART_MONEY">
          <div class="title">
            {{ t('loanProductShelf.productDetail.periodTime') }}
          </div>
          <div class="value">
            <div class="bold">
              {{ paymentTermSM }}
            </div>
            {{ t('loanProductShelf.productDetail.month') }}
          </div>
        </ng-container>
      </div> -->
      <!-- <div *ngIf="productDetail?.limitTime" class="limit-time">
        <span class="title">
          {{ t('loanProductShelf.productDetail.limitTime') }}
        </span>
        <span class="time" id="timer">
          <span class="days"></span>
          {{ t('loanProductShelf.productDetail.day') }}
          <span class="hours"></span>
          {{ t('loanProductShelf.productDetail.hour') }}
          <span class="minute"></span>
          <span class="second"></span>
        </span>
      </div> -->
    </div>
  </ng-container>
</p-card>
